// extracted by mini-css-extract-plugin
export default {"banner":"ContactPage_banner__ubcUI"};